import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CertificateReservationService } from 'app/services/models/certificate-reservation.service';
import { CertificateService } from 'app/services/models/certificate.service';
import { CompanyService } from 'app/services/models/company.service';
import { CustomerSettingService } from 'app/services/models/customer-setting.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-certificate-reservation-dialog',
  templateUrl: './certificate-reservation-dialog.component.html',
  styleUrls: ['./certificate-reservation-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CertificateReservationDialogComponent implements OnInit {
  @Input() data: { data: any, companyId?: number };
  companies: any[];
  certificateForm: FormGroup;
  isSeriesAdd: boolean = false;
  reservationNumbers: string[] = []; // Aralıktaki numaraları saklayacak liste
  customerSetting: any = {};
  constructor(
    public activeModal: NgbActiveModal,
    private companyService: CompanyService,
    private fb: FormBuilder,
    private certificateReservationService: CertificateReservationService,
    private toastrService: ToastrService,
    private certificateService: CertificateService,
    private customerSettingService: CustomerSettingService
  ) { }

  async ngOnInit() {
    console.log(this.data);
    this.certificateForm = this.fb.group({
      reservationNo: [null,
        [
          Validators.required,
          Validators.pattern(/^[0-9]{6,7}$/)
          //Validators.pattern(`^${new Date().getFullYear().toString().slice(-2)}\\d{4,5}$`)
        ]
      ],
      endReservationNo: [null, Validators.pattern(/^[0-9]{6,7}$/)
      ],
      companyId: [null, Validators.required]
    });

    await this.getByCustomerSetting(1);

    await this.getAllCompanies();
    await this.getLastCertificateNo();
    if (this.data.data) {
      this.certificateForm.patchValue({
        companyId: this.data.data.companyId,
        reservationNo: this.data.data.reservedCertificateNo
      })
    }
    if (this.data.companyId) {
      this.certificateForm.patchValue({
        companyId: this.data.companyId,
      })
    }
  }

  async getByCustomerSetting(id) {
    const data = await this.customerSettingService.getCustomerSettingDetail(1);
    this.customerSetting = data;
    console.log(this.customerSetting);
    this.customerSetting = {
      ...data,
      startCertificateNo: data.starteCertificateNo
    };

    if (this.customerSetting.starteCertificateNo != null) {
      const reservationNoControl = this.certificateForm.get('reservationNo');
      reservationNoControl?.setValidators([
        Validators.required,
        Validators.pattern(/^[0-9]{6,7}$/),
        Validators.min(this.customerSetting.startCertificateNo)
      ]);
      reservationNoControl?.updateValueAndValidity();

      const endReservationNoControl = this.certificateForm.get('endReservationNo');
      endReservationNoControl?.setValidators([
        Validators.pattern(/^[0-9]{6,7}$/),
        Validators.min(this.customerSetting.startCertificateNo)
      ]);
      endReservationNoControl?.updateValueAndValidity();
    }
  }

  async getLastCertificateNo() {
    const data = await this.certificateService.getLastCertificate();
    console.log(data);
    this.certificateForm.patchValue({
      reservationNo: data
    })
  }

  async getAllCompanies() {
    const data = await this.companyService.getAllCompany('', 0, 1000);
    console.log(data);
    this.companies = data.companies;
  }

  closeModal(result: boolean = false) {
    this.activeModal.close(result);
  }

  toggleSeries() {
    this.isSeriesAdd = !this.isSeriesAdd;
    if (this.isSeriesAdd) {
      const validators = [
        Validators.required,
        Validators.pattern(/^[0-9]{6,7}$/)
      ];
      if (this.customerSetting?.starteCertificateNo != null) {
        validators.push(Validators.min(this.customerSetting.starteCertificateNo));
      }
    } else {
      this.certificateForm.get('endReservationNo')?.clearValidators();
    }
    this.certificateForm.get('endReservationNo')?.updateValueAndValidity();
  }

  generateReservationNumbers() {
    this.reservationNumbers = []; // Önceki listeyi temizle

    const start = Number(this.certificateForm.value.reservationNo);
    const end = Number(this.certificateForm.value.endReservationNo);

    if (this.isSeriesAdd && start && end && end >= start) {
      for (let i = start; i <= end; i++) {
        this.reservationNumbers.push(i.toString());
      }
      console.log("Oluşturulan numaralar:", this.reservationNumbers);
    }
  }

  async onSubmit() {
    if (this.certificateForm.valid) {
      if (this.data.data) {
        const data = await this.certificateReservationService.updateCertificateReservation(this.data.data.id, this.certificateForm.value.companyId, this.certificateForm.value.reservationNo);
        if (data.status) {
          this.toastrService.success(data.message);
          this.certificateReservationService.sendEvent(true);
          this.closeModal(true);
        } else {
          this.toastrService.error(data.message);
        }
      } else {
        if (!this.isSeriesAdd) {
          console.log(this.certificateForm.value)
          this.reservationNumbers.push(this.certificateForm.value.reservationNo.toString());
          console.log(this.reservationNumbers);
          const data = await this.certificateReservationService.createCertificateReservation(this.certificateForm.value.companyId, this.reservationNumbers);
          if (data.status) {
            this.toastrService.success(data.message, '', { timeOut: 10000, extendedTimeOut: 2000 });
            this.certificateReservationService.sendEvent(true);
            this.closeModal(true);
          } else {
            this.toastrService.error(data.message);
          }
        } else {
          this.generateReservationNumbers();
          const data = await this.certificateReservationService.createCertificateReservation(this.certificateForm.value.companyId, this.reservationNumbers);
          if (data.status) {
            this.toastrService.success(data.message, '', { timeOut: 10000, extendedTimeOut: 2000 });
            this.certificateReservationService.sendEvent(true);
            this.closeModal(true);
          } else {
            this.toastrService.error(data.message, '', { timeOut: 10000, extendedTimeOut: 2000 });
          }
        }
      }
    }
  }
}


/*
 console.log("Form Değerleri:", this.certificateForm.value);
      if (this.data) {
        const data = await this.certificateReservationService.updateCertificateReservation(this.data.id, this.certificateForm.value.companyId, this.certificateForm.value.reservationNo);
        if (data.status) {
          this.toastrService.success(data.message);
          this.certificateReservationService.sendEvent(true);
          this.closeModal();
        } else {
          this.toastrService.error(data.message);
        }
      } else {
        const data = await this.certificateReservationService.createCertificateReservation(this.certificateForm.value.companyId, this.certificateForm.value.reservationNo);
        if (data.status) {
          this.toastrService.success(data.message);
          this.certificateReservationService.sendEvent(true);
          this.closeModal();
        } else {
          this.toastrService.error(data.message);
        }
      }
*/